import { createSelector } from 'reselect'

import { IFormState } from '../models'

export const createFormDataFieldSelector = <V, T = any>(key: string, field: keyof T) =>
  createSelector([({ form }: { form: IFormState<T> }) => ({ form })], ({ form }) => {
    const value = form[key]?.formData[field] as V
    const validationMessage = form[key]?.invalidFields[field] || ''
    const isModified = form[key]?.modifiedFields?.includes(field)

    return {
      value,
      validationMessage,
      isModified,
    }
  })
